<template>
  <div
    class="scs-trash-button-expanding"
    @mouseenter="toggleExpansion"
    @touchstart="toggleExpansion"
    @mouseleave="toggleExpansion"
    @click="clickHandler"
  >
    <svg
      v-if="expanded"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 5.25H3.75"
        stroke="#212121"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.75 9.75V15.75"
        stroke="#212121"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.25 9.75V15.75"
        stroke="#212121"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.75 5.25V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.25"
        stroke="#212121"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 5.25V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H9.75C9.35218 2.25 8.97064 2.40804 8.68934 2.68934C8.40804 2.97064 8.25 3.35218 8.25 3.75V5.25"
        stroke="#212121"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return { expanded: false };
  },
  computed: {},
  methods: {
    toggleExpansion() {
      this.expanded = !this.expanded;
    },
    clickHandler() {
      if (this.expanded) {
        this.$emit("delete");
      }
    },
  },
  created() {},
  components: {},
  props: [],
  emits: ["delete"],
};
</script>
<style scoped>
.scs-trash-button-expanding {
  min-height: 100%;
  min-width: 10px;
  margin-left: 5px;
  border-radius: 8px;
  background-color: #ff8a87;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.scs-trash-button-expanding:hover {
  width: 40px;
  min-width: 40px;
  filter: drop-shadow(0px 0px 2px var(--shadow));
}

svg {
  max-height: 65%;
  max-width: 65%;
}
</style>
